import React, { useState } from 'react'
import styled from 'styled-components'

// Const
import { textInputStylesConfig, textInputStyles } from '../../../_constants/styles'

// Components
import { Button } from '../../../_components/Button'
import { Text } from '../../../_components/Typography/Components/Text/Text'

// Services
import { stopAccruingFeesOnInvoice } from '../../../_services/invoices.service'

//helpers
import { currentDateTimeInUTC, UTCDateToSystemString } from '../../../_helpers/dates'

// Hooks
import { S_Subtitle } from '../../../_components/Typography/Titles.styles'
import colors from '../../../_constants/colors'

const inputWidth = '240px'

const S_FeeModal = styled.div`
  flex: 1 1 0px;
  flex-direction: column;

  input {
    ${textInputStyles}
    width: ${inputWidth};
    max-width: ${inputWidth}; /* prevent text-area overflow*/
    min-width: ${inputWidth};
  }

  .stat {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 3px;

    &.has-input {
      margin-bottom: 20px;

      div:last-child {
        padding-left: 30px;
      }
    }

    div {
      min-height: ${textInputStylesConfig.minHeight};
      display: flex;
      align-items: center;
      color: ${colors.TEXT_DARK};
    }
  }

  .buttons {
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    .cancel-button {
      background-color: red;
      opacity: 0.75;
      &:hover {
        opacity: 1;
      }
      &:disabled {
        opacity: 0.25;
      }
      margin-left: 10px;
    }
  }
`

const AccrueFeesModal = ({ closeModal, invoice, stopFeesSuccessNotify, stopFeeErrorNotify, refreshData }) => {
  const defaultDate = UTCDateToSystemString(currentDateTimeInUTC()).split('T')[0]
  const [stopFeesDate, setStopFeesDate] = useState(defaultDate)

  const onPerformStopFees = async (invoice, stopFeesDate) => {
    try {
      await stopAccruingFeesOnInvoice(invoice.id, stopFeesDate)
      stopFeesSuccessNotify()
    } catch (e) {
      stopFeeErrorNotify()
    } finally {
      closeModal()
    }
  }

  const onCancel = () => {
    closeModal()
  }

  const parsedDate = new Date(stopFeesDate).toLocaleDateString('en-US', { timeZone: 'UTC' })
  return (
    <S_FeeModal>
      <S_Subtitle align={'center'} marginBottom={'20'} weight={'700'}>
        Stop Accruing Fees
      </S_Subtitle>

      <div className={'stat_group'}>
        <div className={'stat has-input'}>
          <div>Date</div>
          <div>
            <input
              defaultValue={defaultDate}
              max={defaultDate}
              min={invoice?.purchase_date?.split('T')[0]}
              onChange={(e) => {
                setStopFeesDate(e.target.value)
              }}
              placeholder="Date"
              type="date"
            />
          </div>
        </div>
      </div>

      <Text>{`Fees will not be charged from ${parsedDate}`}</Text>
      <div className={`buttons`}>
        <Button
          className={`confirm-button`}
          onClick={() => {
            onPerformStopFees(invoice, stopFeesDate).then(() => refreshData())
          }}
          text={'Confirm'}
        />
        <Button className="cancel-button" onClick={onCancel} text={'Cancel'} />
      </div>
    </S_FeeModal>
  )
}

export { AccrueFeesModal }
